const TrainingScheduleAthletes = () =>
  import('@/views/training-schedule/TrainingScheduleAthletes.vue')
const TrainingScheduleTrainers = () =>
  import('@/views/training-schedule/TrainingScheduleTrainers.vue')

const SportsEventsAthletes = () =>
  import('@/views/sports-events/SportsEventsAthletes.vue')
const SportsEventsTrainers = () =>
  import('@/views/sports-events/SportsEventsTrainers.vue')

const Directory = () => import('@/views/Directory.vue')
const KindsSport = () => import('@/views/KindsSport.vue')
const KindsSportCreate = () => import('@/views/KindsSportCreate.vue')
const KindsSportEdit = () => import('@/views/KindsSportEdit.vue')
const SportsObjects = () => import('@/views/SportsObjects.vue')
const SportsObjectsCreate = () => import('@/views/SportsObjectsCreate.vue')
const SportsObjectsEdit = () => import('@/views/SportsObjectsEdit.vue')
const Athletes = () => import('@/views/Athletes.vue')
const AthleteCreate = () => import('@/views/AthleteCreate.vue')
const AthleteEdit = () => import('@/views/AthleteEdit.vue')
const AthleteResult = () => import('@/views/AthleteResult.vue')
const Trainers = () => import('@/views/Trainers.vue')
const TrainerInfo = () => import('@/views/TrainerInfo.vue')
const TrainerSchedule = () => import('@/views/TrainerSchedule.vue')
const TrainerCompetition = () => import('@/views/TrainerCompetition.vue')
const TrainerTrainingGroups = () => import('@/views/TrainerTrainingGroups.vue')
const AthleteUpdate = () => import('@/views/AthleteUpdate.vue')
const TrainingGroups = () =>
  import('@/views/training-groups/TrainingGroups.vue')
const TrainingGroupCreate = () =>
  import('@/views/training-groups/TrainingGroupCreate.vue')
const TrainingGroupEdit = () =>
  import('@/views/training-groups/TrainingGroupEdit.vue')
const TrainingGroupAthletes = () =>
  import('@/views/training-groups/TrainingGroupAthletes.vue')
const TrainingGroupTrainers = () =>
  import('@/views/training-groups/TrainingGroupTrainers.vue')
const TrainingSchedule = () =>
  import('@/views/training-schedule/TrainingSchedule.vue')
const TrainingScheduleTemplate = () =>
  import('@/views/training-schedule/TrainingScheduleTemplate.vue')

const TrainingNtzTemplate = () =>
  import('@/views/training-ntz/TrainingNtzTemplate.vue')

const RolesLayout = () => import('@/views/roles/RolesLayout.vue')
const RoleEdit = () => import('@/views/roles/RoleEdit.vue')
const UsersLayout = () => import('@/views/users/UsersLayout.vue')
const UserCreate = () => import('@/views/users/UserCreate.vue')
const UserInfo = () => import('@/views/users/UserInfo.vue')
const SportsEvents = () => import('@/views/sports-events/SportsEvents.vue')
const SportsEventsCreate = () =>
  import('@/views/sports-events/SportsEventsCreate.vue')
const SportsEventsEdit = () =>
  import('@/views/sports-events/SportsEventsEdit.vue')
const SportsEventsComments = () =>
  import('@/views/sports-events/SportsEventsComments.vue')
const Support = () => import('@/views/Support.vue')
const CalendarEvents = () =>
  import('@/views/calendar-events/CalendarEvents.vue')

const AuthLayout = () => import('@/views/auth/AuthLayout.vue')
const FormLogin = () => import('@/components/form/FormLogin.vue')
const FormVerification = () => import('@/components/form/FormVerification.vue')
const FormCreatePassword = () =>
  import('@/components/form/FormCreatePassword.vue')
const FormResetPassword = () =>
  import('@/components/form/FormResetPassword.vue')
const FormBankId = () => import('@/components/form/FormBankId.vue')
const TrainingScheduleEvents = () =>
  import('@/views/training-schedule/TrainingScheduleEvents.vue')
const TrainingScheduleEventsCreate = () =>
  import('@/views/training-schedule/TrainingScheduleEventsCreate.vue')
const TrainingScheduleEventsEdit = () =>
  import('@/views/training-schedule/TrainingScheduleEventsEdit.vue')
const CalendarPlan = () => import('@/views/calendar-events/CalendarPlan.vue')
const CalendarPlanNew = () =>
  import('@/views/calendar-events/CalendarPlanNew.vue')
const CalendarPlanInfo = () =>
  import('@/views/calendar-events/CalendarPlanInfo.vue')
const Tariffs = () => import('@/views/tariffs/Tariffs.vue')
const Home = () => import('@/views/Home.vue')
const AthleteScholarship = () => import('@/views/AthleteScholarship.vue')
const AnalyticLayout = () => import('@/views/analytics/AnalyticLayout.vue')
const AnalyticAthlete = () => import('@/views/analytics/AnalyticAthlete.vue')
const AnalyticTrainer = () => import('@/views/analytics/AnalyticTrainer.vue')
const AnalyticSportObject = () =>
  import('@/views/analytics/AnalyticSportObject.vue')
const AnalyticScholarship = () =>
  import('@/views/analytics/AnalyticScholarship.vue')
const AnalyticAthleteNew = () =>
  import('@/views/analytics/AnalyticAthleteNew.vue')
const AnalyticAthleteInfo = () =>
  import('@/views/analytics/AnalyticAthleteInfo.vue')
const AnalyticTrainerInfo = () =>
  import('@/views/analytics/AnalyticTrainerInfo.vue')
const AnalyticTrainerNew = () =>
  import('@/views/analytics/AnalyticTrainerNew.vue')
const AnalyticSportObjectNew = () =>
  import('@/views/analytics/AnalyticSportObjectNew.vue')
const AnalyticSportObjectInfo = () =>
  import('@/views/analytics/AnalyticSportObjectInfo.vue')
const AnalyticScholarshipNew = () =>
  import('@/views/analytics/AnalyticScholarshipNew.vue')
const AnalyticScholarshipInfo = () =>
  import('@/views/analytics/AnalyticScholarshipInfo.vue')
const AllUsersLayout = () => import('@/views/all-users/AllUsersLayout.vue')
const AllUsersAthleteInfo = () =>
  import('@/views/all-users/AllUsersAthleteInfo.vue')
const AllUsersAthleteNew = () =>
  import('@/views/all-users/AllUsersAthleteNew.vue')
const AllUsersAthlete = () => import('@/views/all-users/AllUsersAthlete.vue')
const AllUsersParents = () => import('@/views/all-users/AllUsersParents.vue')
const AllUsersParentsInfo = () =>
  import('@/views/all-users/AllUsersParentsInfo.vue')
const AllUsersParentsNew = () =>
  import('@/views/all-users/AllUsersParentsNew.vue')
const FormPassword = () => import('@/components/form/FormPassword.vue')
const SupportInfo = () => import('@/views/SupportInfo.vue')
const TariffsRevision = () => import('@/views/tariffs/TariffsRevision.vue')
const TariffsCalculation = () =>
  import('@/views/tariffs/TariffsCalculation.vue')
const SportsEventsFinance = () =>
  import('@/views/sports-events/SportsEventsFinance.vue')
const FormChangePassword = () =>
  import('@/components/form/FormChangePassword.vue')
const ProfileInfo = () => import('@/views/trainer-profile/ProfileInfo.vue')
const ProfileSchedule = () =>
  import('@/views/trainer-profile/ProfileSchedule.vue')
const ProfileCompetition = () =>
  import('@/views/trainer-profile/ProfileCompetition.vue')
const ProfileTrainingGroups = () =>
  import('@/views/trainer-profile/ProfileTrainingGroups.vue')
const TrainingScheduleFinance = () =>
  import('@/views/training-schedule/TrainingScheduleFinance.vue')
const TrainingScheduleComments = () =>
  import('@/views/training-schedule/TrainingScheduleComments.vue')
const FeedbackLayout = () => import('@/views/feedback/FeedbackLayout.vue')
const FeedbackInfo = () => import('@/views/feedback/FeedbackInfo.vue')
const EnrollmentLayout = () => import('@/views/enrollment/EnrollmentLayout.vue')
const EnrollmentInfo = () => import('@/views/enrollment/EnrollmentInfo.vue')
const ReportingLayout = () => import('@/views/reporting/ReportingLayout.vue')
const ReportingApplications = () =>
  import('@/views/reporting/ReportingApplications.vue')
const ReportingApplicationsNew = () =>
  import('@/views/reporting/ReportingApplicationsNew.vue')
const ReportingApplicationsInfo = () =>
  import('@/views/reporting/ReportingApplicationsInfo.vue')

const ActionsLayout = () => import('@/views/actions/ActionsLayout.vue')
const ActionsMagazine = () => import('@/views/actions/ActionsMagazine.vue')
const ActionsMagazineInfo = () =>
  import('@/views/actions/ActionsMagazineInfo.vue')

const CalendarSchool = () =>
  import('@/views/calendar-school/CalendarSchool.vue')
const CalendarSchoolPlan = () =>
  import('@/views/calendar-school/CalendarSchoolPlan.vue')
const CalendarSchoolPlanNew = () =>
  import('@/views/calendar-school/CalendarSchoolPlanNew.vue')
const CalendarSchoolPlanInfo = () =>
  import('@/views/calendar-school/CalendarSchoolPlanInfo.vue')
const TrainerResult = () => import('@/views/TrainerResult.vue')
const RemovalRequestsLayout = () =>
  import('@/views/removal-requests/RemovalRequestsLayout.vue')
const RemovalRequestsInfo = () =>
  import('@/views/removal-requests/RemovalRequestsInfo.vue')
const FeedbackTrainersLayout = () =>
  import('@/views/feedback-trainers/FeedbackTrainersLayout.vue')
const FeedbackTrainersInfo = () =>
  import('@/views/feedback-trainers/FeedbackTrainersInfo.vue')
const AthleteDocuments = () => import('@/views/AthleteDocuments.vue')
const NewsLayout = () => import('@/views/news/NewsLayout.vue')
const NewsDetail = () => import('@/views/news/NewsDetail.vue')
const NewsNew = () => import('@/views/news/NewsNew.vue')
const StoreLayout = () => import('@/views/store/StoreLayout.vue')
const StoreCreate = () => import('@/views/store/StoreCreate.vue')
const StoreEdit = () => import('@/views/store/StoreEdit.vue')
const MapSheltersLayout = () =>
  import('@/views/map-shelters/MapSheltersLayout.vue')

const CompetitiveActivityLayout = () =>
  import('@/views/competitive-activity/CompetitiveActivityLayout.vue')

const CompetitiveActivityInfo = () =>
  import('@/views/competitive-activity/CompetitiveActivityInfo.vue')

export const routes = [
  {
    path: '/login',
    name: 'login',
    redirect: '/auth/login',
  },

  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {auth: true},
  },

  {
    path: '/directory',
    name: 'directory',
    component: Directory,
    meta: {auth: true},
  },
  {
    path: '/directory/:type',
    name: 'directoryAdd',
    component: Directory,
    meta: {auth: true},
  },

  {
    path: '/competitive-activity',
    name: 'competitiveActivity',
    component: CompetitiveActivityLayout,
    meta: {auth: true},
    children: [
      {
        path: '/competitive-activity/:id/info',
        name: 'competitiveActivityInfo',
        component: CompetitiveActivityInfo,
      },
    ],
  },
  {
    path: '/kinds-sport',
    name: 'kindsSport',
    component: KindsSport,
    redirect: '/kinds-sport/new',
    meta: {auth: true},
    children: [
      {
        path: '/kinds-sport/new',
        name: 'kindsSportCreate',
        component: KindsSportCreate,
        meta: {auth: true},
      },
      {
        path: '/kinds-sport/:id/edit',
        name: 'kindsSportEdit',
        component: KindsSportEdit,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/sports-objects',
    name: 'sportsObjects',
    component: SportsObjects,
    redirect: '/sports-objects/new',
    meta: {auth: true},
    children: [
      {
        path: '/sports-objects/new',
        name: 'sportsObjectNew',
        component: SportsObjectsCreate,
        meta: {auth: true},
      },
      {
        path: '/sports-objects/:id/edit',
        name: 'sportsObjectEdit',
        component: SportsObjectsEdit,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/athlete',
    name: 'athlete',
    component: Athletes,
    meta: {auth: true},
    children: [
      {
        path: '/athlete/new',
        name: 'athleteNew',
        component: AthleteCreate,
      },
      {
        path: '/athlete/:id/edit',
        name: 'athleteEdit',
        component: AthleteEdit,
      },
      {
        path: '/athlete/:id/result',
        name: 'athleteResult',
        component: AthleteResult,
      },
      {
        path: '/athlete/:id/scholarships',
        name: 'athleteScholarships',
        component: AthleteScholarship,
      },
      {
        path: '/athlete/:id/documents',
        name: 'athleteDocuments',
        component: AthleteDocuments,
      },
      {
        path: '/athlete/:id/update',
        name: 'athleteUpdate',
        component: AthleteUpdate,
      },
    ],
  },
  {
    path: '/trainers',
    name: 'trainers',
    component: Trainers,
    meta: {auth: true},
    children: [
      {
        path: '/trainers/:id/info',
        name: 'trainerInfo',
        component: TrainerInfo,
      },
      {
        path: '/trainers/:id/schedule',
        name: 'trainerSchedule',
        component: TrainerSchedule,
      },
      {
        path: '/trainers/:id/competition',
        name: 'trainerCompetition',
        component: TrainerCompetition,
      },
      {
        path: '/trainers/:id/training-groups',
        name: 'trainerTrainingGroups',
        component: TrainerTrainingGroups,
      },
      {
        path: '/trainers/:id/result',
        name: 'trainerResult',
        component: TrainerResult,
      },
    ],
  },
  {
    path: '/profile',
    name: 'profile',
    component: Trainers,
    meta: {auth: true},
    children: [
      {
        path: '/profile/:id/info',
        name: 'profileInfo',
        component: ProfileInfo,
      },
      {
        path: '/profile/:id/schedule',
        name: 'profileSchedule',
        component: ProfileSchedule,
      },
      {
        path: '/profile/:id/competition',
        name: 'profileCompetition',
        component: ProfileCompetition,
      },
      {
        path: '/profile/:id/training-groups',
        name: 'profileTrainingGroups',
        component: ProfileTrainingGroups,
      },
    ],
  },
  {
    path: '/training-groups',
    name: 'trainingGroups',
    component: TrainingGroups,
    meta: {auth: true},
    children: [
      {
        path: '/training-groups/new',
        name: 'trainingGroupNew',
        component: TrainingGroupCreate,
      },
      {
        path: '/training-groups/:id/edit',
        name: 'trainingGroupEdit',
        component: TrainingGroupEdit,
      },
      {
        path: '/training-groups/:id/athletes',
        name: 'trainingGroupAthletes',
        component: TrainingGroupAthletes,
      },
      {
        path: '/training-groups/:id/trainers',
        name: 'trainingGroupTrainers',
        component: TrainingGroupTrainers,
      },
    ],
  },
  {
    path: '/trainings-schedule',
    name: 'trainingSchedule',
    component: TrainingSchedule,
    meta: {auth: true},
  },
  {
    path: '/trainings-schedule/:schoolId',
    name: 'trainingScheduleSchool',
    component: TrainingSchedule,
    meta: {auth: true},
  },
  {
    path: '/competitions',
    name: 'competitionsList',
    meta: {auth: true},
    component: TrainingScheduleEvents,
    children: [
      {
        path: '/competitions/new',
        name: 'competitionsNew',
        component: TrainingScheduleEventsCreate,
      },
      {
        path: '/competitions/:id/edit',
        name: 'competitionsEdit',
        component: TrainingScheduleEventsEdit,
      },
      {
        path: '/competitions/:id/:type/comments',
        name: 'competitionsComments',
        component: TrainingScheduleComments,
        meta: {auth: true},
      },
      {
        path: '/competitions/:id/:type/finance',
        name: 'competitionsFinance',
        component: TrainingScheduleFinance,
        meta: {auth: true},
      },
      {
        path: '/competitions/:id/:type/athletes',
        name: 'competitionsAthletes',
        component: TrainingScheduleAthletes,
        meta: {auth: true},
      },
      {
        path: '/competitions/:id/:type/trainers',
        name: 'competitionsTrainers',
        component: TrainingScheduleTrainers,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/trainings-template',
    name: 'trainingTemplate',
    component: TrainingScheduleTemplate,
    meta: {auth: true},
  },
  {
    path: '/ntz-template',
    name: 'ntzTemplate',
    component: TrainingNtzTemplate,
    meta: {auth: true},
  },
  {
    path: '/roles',
    name: 'roles',
    component: RolesLayout,
    meta: {auth: true},
    children: [
      {
        path: '/roles/:id/edit',
        name: 'roleEdit',
        component: RoleEdit,
      },
    ],
  },
  {
    path: '/users',
    name: 'users',
    component: UsersLayout,
    meta: {auth: true},
    children: [
      {
        path: '/users/new',
        name: 'userCreate',
        component: UserCreate,
      },
      {
        path: '/users/:id/edit',
        name: 'userEdit',
        component: UserCreate,
      },
      {
        path: '/users/:id/info',
        name: 'userInfo',
        component: UserInfo,
      },
    ],
  },
  {
    path: '/news',
    name: 'news',
    component: NewsLayout,
    meta: {auth: true},
    children: [
      {
        path: '/news/new',
        name: 'newsNew',
        component: NewsNew,
      },
      {
        path: '/news/:id/detail',
        name: 'newsDetail',
        component: NewsDetail,
      },
    ],
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: FeedbackLayout,
    meta: {auth: true},
    children: [
      {
        path: '/feedback/:id/info',
        name: 'feedbackInfo',
        component: FeedbackInfo,
      },
    ],
  },
  {
    path: '/feedback-trainers',
    name: 'feedbackTrainers',
    component: FeedbackTrainersLayout,
    meta: {auth: true},
    children: [
      {
        path: '/feedback-trainers/:id/info',
        name: 'feedbackTrainerInfo',
        component: FeedbackTrainersInfo,
      },
    ],
  },
  {
    path: '/enrollment',
    name: 'enrollment',
    component: EnrollmentLayout,
    meta: {auth: true},
    children: [
      {
        path: '/enrollment/:id/info',
        name: 'enrollmentInfo',
        component: EnrollmentInfo,
      },
    ],
  },
  {
    path: '/removal-requests',
    name: 'removalRequests',
    component: RemovalRequestsLayout,
    meta: {auth: true},
    children: [
      {
        path: '/removal-requests/:id/info',
        name: 'removalRequestsInfo',
        component: RemovalRequestsInfo,
      },
    ],
  },
  {
    path: '/sports-events',
    name: 'sportsEvents',
    component: SportsEvents,
    meta: {auth: true},
    children: [
      {
        path: '/sports-events/new',
        name: 'sportsEventsNew',
        component: SportsEventsCreate,
        meta: {auth: true},
      },
      {
        path: '/sports-events/:id/edit',
        name: 'sportsEventsEdit',
        component: SportsEventsEdit,
        meta: {auth: true},
      },
      {
        path: '/sports-events/:id/athletes',
        name: 'sportsEventsAthletes',
        component: SportsEventsAthletes,
        meta: {auth: true},
      },
      {
        path: '/sports-events/:id/trainers',
        name: 'sportsEventsTrainers',
        component: SportsEventsTrainers,
        meta: {auth: true},
      },
      {
        path: '/sports-events/:id/:type/comments',
        name: 'sportsEventsComments',
        component: SportsEventsComments,
        meta: {auth: true},
      },
      {
        path: '/sports-events/:id/:type/finance',
        name: 'sportsEventsFinance',
        component: SportsEventsFinance,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/support',
    name: 'support',
    component: Support,
    meta: {auth: true},
  },
  {
    path: '/calendar-events',
    name: 'calendarEvents',
    component: CalendarEvents,
    meta: {auth: true},
  },
  {
    path: '/calendar-events/plan',
    name: 'calendarPlan',
    component: CalendarPlan,
    meta: {auth: true},
  },
  {
    path: '/calendar-events/plan/new',
    name: 'calendarPlanNew',
    component: CalendarPlanNew,
    meta: {auth: true},
  },
  {
    path: '/calendar-events/plan/:id',
    name: 'calendarPlanInfo',
    component: CalendarPlanInfo,
    meta: {auth: true},
  },
  {
    path: '/calendar-school',
    name: 'calendarSchool',
    component: CalendarSchool,
    meta: {auth: true},
  },
  {
    path: '/calendar-school/plan',
    name: 'calendarSchoolPlan',
    component: CalendarSchoolPlan,
    meta: {auth: true},
  },
  {
    path: '/calendar-school/plan/new',
    name: 'calendarSchoolPlanNew',
    component: CalendarSchoolPlanNew,
    meta: {auth: true},
  },
  {
    path: '/calendar-school/plan/:id',
    name: 'calendarSchoolPlanInfo',
    component: CalendarSchoolPlanInfo,
    meta: {auth: true},
  },
  {
    path: '/tariffs',
    name: 'tariffs',
    component: Tariffs,
    meta: {auth: true},
    children: [
      {
        path: '/tariffs/revision',
        name: 'tariffsRevision',
        component: TariffsRevision,
      },
      {
        path: '/tariffs/calculation',
        name: 'tariffsCalculation',
        component: TariffsCalculation,
      },
    ],
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthLayout,
    children: [
      {
        path: '/auth/login',
        name: 'authLogin',
        component: FormLogin,
      },
      {
        path: '/auth/password',
        name: 'authPassword',
        component: FormPassword,
      },
      {
        path: '/auth/register/sms',
        name: 'authVerification',
        component: FormVerification,
      },
      {
        path: '/auth/create-password',
        name: 'authCreatePassword',
        component: FormCreatePassword,
      },
      {
        path: '/auth/change-password/:state',
        name: 'authChangePassword',
        component: FormChangePassword,
      },
      {
        path: '/auth/reset-password/:state',
        name: 'authResetPassword',
        component: FormResetPassword,
      },
      {
        path: '/auth/bank-id',
        name: 'authBankId',
        component: FormBankId,
      },
      {
        path: '/auth/support',
        name: 'authSupport',
        component: SupportInfo,
      },
    ],
  },
  {
    path: '/reporting',
    name: 'reporting',
    component: ReportingLayout,
    meta: {auth: true},
    children: [
      {
        path: '/reporting/applications',
        name: 'reportingApplications',
        component: ReportingApplications,
      },
      {
        path: '/reporting/applications/new',
        name: 'reportingApplicationsNew',
        component: ReportingApplicationsNew,
      },
      {
        path: '/reporting/applications/:id/info',
        name: 'reportingApplicationsInfo',
        component: ReportingApplicationsInfo,
      },
    ],
  },
  {
    path: '/actions',
    name: 'actions',
    component: ActionsLayout,
    meta: {auth: true},
    children: [
      {
        path: '/actions/magazine',
        name: 'actionsMagazine',
        component: ActionsMagazine,
      },
      {
        path: '/actions/magazine/:id/info',
        name: 'actionsMagazineInfo',
        component: ActionsMagazineInfo,
      },
    ],
  },
  {
    path: '/store',
    name: 'storeLayout',
    component: StoreLayout,
    redirect: '/store/new',
    meta: {auth: true},
    children: [
      {
        path: '/store/new',
        name: 'storeNew',
        component: StoreCreate,
        meta: {auth: true},
      },
      {
        path: '/store/:id/edit',
        name: 'storeEdit',
        component: StoreEdit,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/map-shelters',
    name: 'mapShelters',
    component: MapSheltersLayout,
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: AnalyticLayout,
    meta: {auth: true},
    children: [
      {
        path: '/analytics/athletes',
        name: 'analyticsAthletes',
        component: AnalyticAthlete,
      },
      {
        path: '/analytics/athletes/new',
        name: 'analyticsAthletesNew',
        component: AnalyticAthleteNew,
      },
      {
        path: '/analytics/athletes/:id/info',
        name: 'analyticsAthleteInfo',
        component: AnalyticAthleteInfo,
      },
      {
        path: '/analytics/trainers',
        name: 'analyticsTrainers',
        component: AnalyticTrainer,
      },
      {
        path: '/analytics/trainers/new',
        name: 'analyticTrainerNew',
        component: AnalyticTrainerNew,
      },
      {
        path: '/analytics/trainers/:id/info',
        name: 'analyticsTrainerInfo',
        component: AnalyticTrainerInfo,
      },
      {
        path: '/analytics/sport-object',
        name: 'analyticsSportObject',
        component: AnalyticSportObject,
      },
      {
        path: '/analytics/sport-object/new',
        name: 'analyticsSportObjectNew',
        component: AnalyticSportObjectNew,
      },
      {
        path: '/analytics/sport-object/:id/info',
        name: 'analyticsSportObjectInfo',
        component: AnalyticSportObjectInfo,
      },
      {
        path: '/analytics/scholarship',
        name: 'analyticsScholarship',
        component: AnalyticScholarship,
      },
      {
        path: '/analytics/scholarship/new',
        name: 'analyticsScholarshipNew',
        component: AnalyticScholarshipNew,
      },
      {
        path: '/analytics/scholarship/:id/info',
        name: 'analyticsScholarshipInfo',
        component: AnalyticScholarshipInfo,
      },
    ],
  },
  {
    path: '/all-users',
    name: 'allUsers',
    component: AllUsersLayout,
    meta: {auth: true},
    children: [
      {
        path: '/all-users/athletes',
        name: 'allUsersAthletes',
        component: AllUsersAthlete,
      },
      {
        path: '/all-users/athletes/:id/info',
        name: 'allUsersAthletesInfo',
        component: AllUsersAthleteInfo,
      },
      {
        path: '/all-users/athletes/new',
        name: 'allUsersAthletesNew',
        component: AllUsersAthleteNew,
      },
      {
        path: '/all-users/parents',
        name: 'allUsersParents',
        component: AllUsersParents,
      },
      {
        path: '/all-users/parents/:id/info',
        name: 'allUsersParentsInfo',
        component: AllUsersParentsInfo,
      },
      {
        path: '/all-users/parents/new',
        name: 'allUsersParentsNew',
        component: AllUsersParentsNew,
      },
    ],
  },
]
